import {request} from "./request"

export function getHotProduct(params) {
    return request({
        url: '/api/loan/product/h5/product-paging',
        methods: 'GET',
        params
    })
}